var module = angular.module('octopusApp.tenants');

module.directive('tenantedDeploymentParticipation', function () {
    return {
        restrict: 'E',
        replace: true,
        transclude: false,
        scope: {
            model: '=',
            resourceTypeLabel: '='
        },
        templateUrl: 'areas/tenants/views/tenanted-deployment-participation.html',
        controllerAs: 'vm',
        bindToController: true,
        controller: function () {
        }
    };
});




//////////////////
// WEBPACK FOOTER
// ./app/areas/tenants/directives/tenanted-deployment-participation.js
// module id = 65600241094336
// module chunks = 1